<script lang="ts">
    import SettingsRouteCost from '../Settings/SettingsRouteCost.svelte';
    export let componentProps: any = {};
</script>

<SettingsRouteCost {...componentProps} />
